import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M16 2v4M8 2v4\"></path><path d=\"M10.5 22c-3.438 0-5.213 0-6.32843-1.1716C3 19.6569 3 17.7712 3 14v-2c0-3.77124 0-5.65685 1.17157-6.82843C5.34315 4 7.22876 4 11 4h2c3.7712 0 5.6569 0 6.8284 1.17157C21 6.34315 21 8.22876 21 11.5\"></path><path d=\"M3 10h18\"></path><path d=\"M12 17.5c1.2-2 3-3 5.25-3s4.05 1 5.25 3c-1.2 2-3 3-5.25 3s-4.05-1-5.25-3Z\"></path><circle cx=\"17.25\" cy=\"17.5\" r=\"1.25\"></circle>", 5)
  ]))]))
}
export default { render: render }